import React, { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { SITE } from "@/data/site";

const links = [
    { to: "/", label: "Início", testId: "nav-home" },
    { to: "/areas-de-atuacao", label: "Áreas de Atuação", testId: "nav-areas" },
    { to: "/recrutamento", label: "Recrutamento", testId: "nav-recruitment" },
    { to: "/artigos", label: "Artigos", testId: "nav-articles" },
    { to: "/press", label: "Press", testId: "nav-press" },
];

const Header = () => {
    const [open, setOpen] = useState(false);

    return (
        <header className="acd-header" data-testid="site-header">
            <div className="max-w-7xl mx-auto px-5 md:px-8 flex items-center justify-between h-20">
                <Link to="/" className="flex items-center gap-3" data-testid="logo-link">
                    <img
                        src={SITE.logoUrl}
                        alt="ACD Advogados"
                        className="h-14 w-auto"
                    />
                </Link>

                <nav className="hidden lg:flex items-center gap-8">
                    {links.map((l) => (
                        <NavLink
                            key={l.to}
                            to={l.to}
                            end={l.to === "/"}
                            className={({ isActive }) =>
                                `acd-nav-link ${isActive ? "active" : ""}`
                            }
                            data-testid={l.testId}
                        >
                            {l.label}
                        </NavLink>
                    ))}
                    <a
                        href="/#contactos"
                        className="acd-nav-link"
                        data-testid="nav-contacts"
                    >
                        Contactos
                    </a>
                    <a
                        href="/#contactos"
                        className="acd-btn-gradient"
                        data-testid="nav-cta-contact"
                    >
                        Contacte-nos
                    </a>
                </nav>

                <button
                    className="lg:hidden text-navy-900"
                    onClick={() => setOpen((v) => !v)}
                    aria-label="Abrir menu"
                    data-testid="mobile-menu-toggle"
                >
                    {open ? <X size={28} /> : <Menu size={28} />}
                </button>
            </div>

            {open && (
                <div
                    className="lg:hidden border-t border-gray-100 bg-white px-6 py-4"
                    data-testid="mobile-menu"
                >
                    <div className="flex flex-col gap-4">
                        {links.map((l) => (
                            <NavLink
                                key={l.to}
                                to={l.to}
                                end={l.to === "/"}
                                onClick={() => setOpen(false)}
                                className={({ isActive }) =>
                                    `acd-nav-link ${isActive ? "active" : ""}`
                                }
                                data-testid={`${l.testId}-mobile`}
                            >
                                {l.label}
                            </NavLink>
                        ))}
                        <a
                            href="/#contactos"
                            onClick={() => setOpen(false)}
                            className="acd-nav-link"
                            data-testid="nav-contacts-mobile"
                        >
                            Contactos
                        </a>
                        <a
                            href="/#contactos"
                            onClick={() => setOpen(false)}
                            className="acd-btn-gradient self-start"
                            data-testid="nav-cta-contact-mobile"
                        >
                            Contacte-nos
                        </a>
                    </div>
                </div>
            )}
        </header>
    );
};

export default Header;
